import React from 'react';
import Products from '../Product/Product';
import GuestHome from './GuestHome';

const Home = (props) => {
    const { user } = props

    return (
        <div>
            {user?.userType === 'business' ?
                <Products {...props} />
                :
                <GuestHome {...props} />
            }
        </div>
    )
}

export default Home